import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export var CloseIcon = function (_a) {
    var _b = _a.size, size = _b === void 0 ? "24" : _b, className = _a.className;
    return (_jsxs("svg", { className: className, width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", children: [_jsx("line", { x1: "18", y1: "6", x2: "6", y2: "18" }), _jsx("line", { x1: "6", y1: "6", x2: "18", y2: "18" })] }));
};
